<template>
    <div class="p-pb-3">
        <input-switch v-model="show_speakers" @change="showSpeakersChanged"/>
        <label>Show Speakers</label>
    </div>
</template>

<script>
import InputSwitch from 'primevue/inputswitch'
import SelectButton from 'primevue/selectbutton'

export default {
  name: 'SpeakersToggle',
  components: {
    InputSwitch,
    SelectButton
  },
  data: function () {
    return {
      show_speakers: this.$store.getters['settings/showSpeakersOnScreen']
    }
  },
  methods: {
    showSpeakersChanged (e) {
      console.log('show speakers changed')
      if (this.show_speakers) {
        this.$store.dispatch('settings/saveShowSpeakers')
      } else {
        this.$store.dispatch('settings/saveHideSpeakers')
      }
      this.$store.commit('motions/SET_SHOW_SPEAKERS_ON_SCREEN', this.show_speakers)
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/speakers/SpeakersToggle.vue